module.exports = __webpack_public_path__ + "static/img/pdf-80px.8393d3d7.png";